import * as pdfjsLib from 'pdfjs-dist'

// Worker lives in /public so CRA can serve it at runtime
pdfjsLib.GlobalWorkerOptions.workerSrc =
  process.env.PUBLIC_URL + '/pdf.worker.min.mjs'

/**
 * Extracts all text from a PDF File object.
 * Returns a plain string with pages separated by double newlines.
 */
export async function extractTextFromPdf(file) {
  const arrayBuffer = await file.arrayBuffer()
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise

  const pages = []
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i)
    const content = await page.getTextContent()
    // Join items; insert spaces between words that run together
    const pageText = content.items
      .map((item) => item.str)
      .join(' ')
      .replace(/\s{2,}/g, ' ')
      .trim()
    if (pageText) pages.push(pageText)
  }

  return pages.join('\n\n')
}
